var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    transform: "translate(0, 3)",
    viewBox: "0 0 30 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.4085,
    height: 29,
    rx: 5,
    fill: "#128B9B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    transform: "translate(3, 3) scale(0.8, 0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 22,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 16,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.c1b3a2d1d57eeaa86cce60199e2be7ff.svg";
export { ForwardRef as ReactComponent };